import { Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { BalanceHistoryFilter } from '@components/Billing/Balance/BalanceHistoryFilter';
import { BalanceHistoryTable } from '@components/Billing/Balance/BalanceHistoryTable';
import { Page404 } from '@containers/ErrorPages';
import { billingApi } from '@reducers/billing';

export const BalanceHistory = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isPrepaid } = useSelector((state) => state.auth.user);
  if (!isPrepaid) {
    return <Page404 />;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        showCalls: searchParams.get('showCalls') || false,
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <BalanceHistoryFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <BalanceHistoryTable
            useData={billingApi.useGetBalanceHistoryQuery}
            searchParams={searchParams}
          />
        </Col>
      </Form>
    </Formik>
  );
};
